<template>
  <a-modal :title="form.banner ? '修改信息' : '新增信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false" width="500px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="图片素材" prop="url">
        <draggable v-model="form.images" :sort="true" key="456" class="imagebox">
          <div class="imgcontainer" :style="{ width: 120 + 'px', height: 120 + 'px' }" v-if="form.url">
            <img crossorigin alt="img" :src="form.url">
            <div class="delimg" @click.stop="delimg(form.url = '')">
              <a-icon type="close" />
            </div>
          </div>
          <a-upload-dragger class="imgcontainer" name="file" loading style="height: 100%;" v-if="!form.url"
            :style="{ width: 120 + 'px', height: 120 + 'px' }" :multiple="false" :showUploadList="false"
            :customRequest="onDrop">
            <p class="ant-upload-drag-icon" style="margin: 0;">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-hint">点击或拖拽至此上传</p>
          </a-upload-dragger>
        </draggable>
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input-number v-model="form.sort" :min="0" placeholder="排序" />
      </a-form-model-item>
    </a-form-model>
    <input type="file" id="imageInput" @change="changefile" hidden accept="image/*" />
  </a-modal>
</template>

<script>
import draggable from "vuedraggable";
import "element-ui/lib/theme-chalk/index.css";
export default {
  components: { draggable },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        title: "",
        url: "",
        sort: 0
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        url: [
          {
            required: true,
            message: "请上传banner图片",
            trigger: "blur",
          },
        ],
        title: [
          {
            required: false,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
  },
  methods: {
    // 处理文件拖放
    onDrop(event) {
      if (!event) return
      const isJpgOrPng = event.file.type === 'image/jpeg' || event.file.type === 'image/png' || event.file.type === 'image/jpg';
      if (!isJpgOrPng) {
        return this.$message.error('只能上传图片文件!');
      }
      const droppedFiles = event.file;
      // this.handleFiles(droppedFiles);
      this.changefile(droppedFiles)
    },

    changefile(file) {
      // const file = files[0];
      if (file) {
        // console.log("图片名称:", file);
        // const reader = new FileReader();
        // reader.onload = (e) => {
        //     // this.imageSrc = e.target.result;
        //     this.DataList[this.imageIndex].value.push(e.target.result)
        // };
        // reader.readAsDataURL(file);
        const formData = new FormData();
        formData.append('file', file);
        this.spinning = true
        this.$http({
          url: '/admin/sys/upload',
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data', // 告诉服务器上传的是文件
          },
          data: formData
        }).then(res => {
          this.form.url = res.data.url
        })
      } else {
        console.log("未选择图片");
      }
      document.getElementById('imageInput').value = '';
    },
    init(id) {
      this.visible = true;
      this.form.banner = id;
      if (id) {
        this.$http({
          url: "/admin/appbanner/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = {
            ...res.data,
          }
        });
      }
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
          };
          this.$http({
            url: this.form.banner ? "/admin/appbanner/update" : "/admin/appbanner/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.banner ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.custom-tree-node {
  display: flex;
  width: 100%;
  /* border: 1px solid red; */
}
</style>
<style scoped lang="scss">
.imagebox {
  display: flex;
  // justify-content: center;
  flex-wrap: wrap;

  .imgcontainer {
    width: 100px;
    height: 100px;
    background: #FFF;
    margin: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .delimg {
      position: absolute;
      width: 25%;
      height: 25%;
      background: red;
      color: #FFF;
      right: 5%;
      top: 5%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 100%;
      font-weight: bold;
    }
  }
}
</style>